import {
  GET_DOWNLOAD_LINK
} from '@/store/mutations_types'

const mutations = {
  [GET_DOWNLOAD_LINK](state, context) {
    state.session = context.session
    state.downloadLink_copy = context.download_link_copy
    state.downloadLink_qrcode = context.download_link_qrcode
    state.lang = context.lang
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/Common/mutations.js